
import { Vue } from 'vue-class-component';

export default class CloseIcon extends Vue {}
